<template lang="pug">
div.pl-4.align-self-center
  v-icon(small color="green") fas fa-circle
  span.pl-1 {{ $t('bankTransactionPage.processedCount') }}:
  span.pl-1.font-weight-bold.value {{getProcessedValue}}
  v-icon.pl-4(small color="orange") fas fa-circle
  span.pl-1 {{ $t('bankTransactionPage.unprocessedCount') }}:
  span.pl-1.font-weight-bold.value {{getUnProcessedValue}}
  v-icon.pl-4(small color="grey") fas fa-circle
  span.pl-1 {{ $t('bankTransactionPage.ignoredTransactionLabel') }}:
  span.pl-1.font-weight-bold.value {{getIgnoredValue}}


</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import BankTransaction from "@/model/BankTransaction/BankTransaction";
import {IStatusPanelParams, ModelUpdatedEvent, RowNode} from "ag-grid-community";

@Component({
  components: {}
})
export default class BankTransactionCustomStatusPanel extends Vue {

  private bankTransactionList: BankTransaction[] = []
  private params!: IStatusPanelParams

  get getUnProcessedValue() {
    return this.bankTransactionList.filter((item: BankTransaction) => item.transaction.status === 'not_processed').length
  }

  get getProcessedValue() {
    return this.bankTransactionList.filter((item: BankTransaction) => item.transaction.status === 'done').length
  }

  get getIgnoredValue() {
    return this.bankTransactionList.filter((item: BankTransaction) => item.transaction.status === 'ignored').length
  }

  mounted() {
    this.params.api.addEventListener('modelUpdated' ,(evt: ModelUpdatedEvent) => {
      let data: BankTransaction[] = []
      evt.api.forEachNodeAfterFilter((params: RowNode) => {
        data.push(params.data)
      })
      this.bankTransactionList = data
    })
  }
}
</script>

<style lang="stylus" scoped>
.value
  color black
</style>